import React from 'react';
import {BASIC_ELEMENT_SCHEMA} from "./Group";
import {merge} from "lodash";
import {propsToCSS} from "../css";

export function Text({value, ...props}) {
  return <span {...propsToCSS(props)}>{value}</span>;
}

Text.schema = merge({
  properties: {
    value: {
      type: 'string',
    },
  }
}, BASIC_ELEMENT_SCHEMA);